import React, { useState } from "react";
import './Carousel.css'

function Carousel() {
    const [activePhoto, setActivePhoto] = useState(0)

    function incrementActivePhoto() {
        let activePhotoNumber = activePhoto
        if (activePhoto === slideImages.length - 1)
            setActivePhoto(0)
        else
            setActivePhoto(activePhotoNumber + 1)
    }
    function decrementActivePhoto() {
        let activePhotoNumber = activePhoto
        if (activePhoto === 0)
            setActivePhoto(slideImages.length - 1)
        else
            setActivePhoto(activePhotoNumber - 1)
    }

    const slideImages = [
        {
            src: "https://live.staticflickr.com/65535/55533733738_da9721f036_b.jpg",
            caption: "chrysanthemum flower still"
        },
        {
            src: "https://live.staticflickr.com/65535/55533774609_4a3761a9c2_b.jpg",
            caption: 'bee resting on a cherry blossom tree',
        },
        {
            src: "https://live.staticflickr.com/65535/55533733723_ffe11b3fae_b.jpg",
            caption: 'hanging baskets at Longwood Gardens',
        },
        {
            src: "https://live.staticflickr.com/65535/55533617996_d707be15fd_b.jpg",
            caption: "dahlias in my grandma's garden"
        },
        {
            src: "https://live.staticflickr.com/65535/55534008680_f1daf092ab_b.jpg",
            caption: "fernery at Morris Arboretum"
        },
        {
            src: "https://live.staticflickr.com/65535/55534008570_7123b18e6c_b.jpg",
            caption: 'spider web on a bronze garden statue',
        }, {
            src: "https://live.staticflickr.com/65535/55533733878_1ddfb44007_b.jpg",
            caption: 'side by side waterlily stills',
        }
    ]
    return (
        <div>
            <img className="activeCarouselImage" src={slideImages[activePhoto].src} alt={slideImages[activePhoto].caption} />
            <div className="row carouselRow">
                <div className="carouselButtonDiv" onClick={() => decrementActivePhoto()} >
                    <svg fill="#fff" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                        <path d="M242 180.6v-138L0 256l242 213.4V331.2h270V180.6z" />
                    </svg>
                </div>
                <p className="activePhotoCaption"> {slideImages[activePhoto].caption} </p>
                <div className="carouselButtonDiv" onClick={() => incrementActivePhoto()} >
                    <svg fill="#fff" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                        <path d="M512 256L270 42.6v138.2H0v150.6h270v138z" />
                    </svg>
                </div>
                </div>
        </div >
    );
}
export default Carousel;